/* Powder Room Niseko — behaviour for the pr-* sections. No dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ---------- Analytics: WhatsApp / booking clicks ---------- */
  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
    try {
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, data || {}));
    } catch (e) {}
  }

  document.addEventListener('click', function (event) {
    var el = event.target.closest('[data-pr-track]');
    if (el) track('pr_cta_click', { cta: el.getAttribute('data-pr-track'), href: el.getAttribute('href') || '' });
  });

  /* ---------- Header height -> CSS var (hero height, sticky poster) ---------- */
  function setHeaderHeight() {
    var header = document.querySelector('.section-header');
    if (header) document.documentElement.style.setProperty('--pr-header-h', header.offsetHeight + 'px');
  }

  /* ---------- Hero slideshow ---------- */
  function initHero(root) {
    $all('[data-pr-hero]', root).forEach(function (hero) {
      if (hero.__prInit) return;
      hero.__prInit = true;
      var slides = $all('.pr-hero__slide', hero);
      var dots = $all('.pr-hero__dot', hero);
      if (slides.length < 2) return;
      var index = 0;
      var delay = parseInt(hero.getAttribute('data-interval'), 10) * 1000 || 6000;
      var timer = null;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === index);
          s.setAttribute('aria-hidden', n === index ? 'false' : 'true');
        });
        dots.forEach(function (d, n) { d.setAttribute('aria-current', n === index ? 'true' : 'false'); });
      }

      function play() {
        if (reduceMotion || hero.getAttribute('data-autoplay') !== 'true') return;
        stop();
        timer = window.setInterval(function () { show(index + 1); }, delay);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function () { show(n); play(); });
      });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', play);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
      hero.addEventListener('shopify:block:select', function (e) {
        var i = slides.indexOf(e.target);
        if (i > -1) { stop(); show(i); }
      });
      show(0);
      play();
    });
  }

  /* ---------- Horizontal scrollers ---------- */
  function initScrollers(root) {
    $all('[data-pr-scroller]', root).forEach(function (wrap) {
      if (wrap.__prInit) return;
      wrap.__prInit = true;
      var track = wrap.querySelector('[data-pr-track]');
      var prev = wrap.querySelector('[data-pr-prev]');
      var next = wrap.querySelector('[data-pr-next]');
      if (!track) return;

      function step() {
        var item = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }

      var nav = prev ? prev.closest('.pr-scroller__nav') : null;

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        if (nav) nav.style.visibility = max <= 0 ? 'hidden' : '';
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Dialogs ---------- */
  function openDialog(dialog, opener) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    dialog.__prOpener = opener || null;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    return true;
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-pr-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-pr-open'));
      if (openDialog(dialog, opener)) event.preventDefault();
      return;
    }
    var closer = event.target.closest('[data-pr-close]');
    if (closer) {
      var dlg = closer.closest('dialog');
      if (dlg) dlg.close();
      return;
    }
    // Click on the backdrop closes the dialog
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('pr-dialog')) {
      var rect = event.target.getBoundingClientRect();
      var inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) event.target.close();
    }
  });

  document.addEventListener('close', function (event) {
    if (event.target.tagName !== 'DIALOG' || !event.target.classList.contains('pr-dialog')) return;
    document.documentElement.style.overflow = '';
    var opener = event.target.__prOpener;
    if (opener && typeof opener.focus === 'function') opener.focus();
  }, true);

  /* ---------- Gallery lightbox ---------- */
  function initLightbox(root) {
    $all('[data-pr-lightbox]', root).forEach(function (section) {
      if (section.__prInit) return;
      section.__prInit = true;
      var dialog = section.querySelector('dialog');
      var items = $all('[data-pr-lightbox-item]', section);
      if (!dialog || !items.length) return;
      var img = dialog.querySelector('img');
      var caption = dialog.querySelector('figcaption');
      var current = 0;

      function show(i) {
        current = (i + items.length) % items.length;
        var item = items[current];
        img.src = item.getAttribute('data-full');
        img.alt = item.getAttribute('data-alt') || '';
        caption.textContent = item.getAttribute('data-caption') || '';
        caption.hidden = !caption.textContent;
      }

      items.forEach(function (item, i) {
        item.addEventListener('click', function () { show(i); openDialog(dialog, item); });
      });
      dialog.querySelector('[data-pr-lb-prev]').addEventListener('click', function () { show(current - 1); });
      dialog.querySelector('[data-pr-lb-next]').addEventListener('click', function () { show(current + 1); });
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
      });
    });
  }

  /* ---------- Booking / careers forms -> WhatsApp message ---------- */
  function fieldValue(field) {
    if (field.type === 'radio') return field.checked ? field.value : '';
    if (field.type === 'checkbox') return '';
    if (field.type === 'date' && field.value) {
      // "2026-12-31" -> "Thu, 31 Dec 2026" (read as a calendar date, no timezone shift)
      var parts = field.value.split('-');
      var d = new Date(Date.UTC(+parts[0], +parts[1] - 1, +parts[2]));
      return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
    }
    return (field.value || '').trim();
  }

  // The wrapper [data-pr-compose] carries the WhatsApp number + intro line; fields live inside it.
  function initComposer(root) {
    $all('[data-pr-compose]', root).forEach(function (form) {
      if (form.__prInit) return;
      form.__prInit = true;
      var sendWa = form.querySelector('[data-pr-send-wa]');
      var error = form.querySelector('[data-pr-error]');
      var dateInput = form.querySelector('input[type="date"]');

      if (dateInput && !dateInput.min) {
        var now = new Date();
        dateInput.min = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      }

      if (!sendWa) return;
      sendWa.addEventListener('click', function (event) {
        event.preventDefault();
        var missing = [];
        var lines = [form.getAttribute('data-pr-intro') || ''];
        var seen = {};

        $all('[data-pr-label]', form).forEach(function (field) {
          var label = field.getAttribute('data-pr-label');
          var value = fieldValue(field);
          if (field.type === 'radio') {
            if (seen[label] === undefined) seen[label] = '';
            if (value) seen[label] = value;
            return;
          }
          if (field.hasAttribute('data-pr-wa-required') && !value) {
            missing.push(label);
            field.setAttribute('aria-invalid', 'true');
          } else {
            field.removeAttribute('aria-invalid');
          }
          if (value) lines.push(label + ': ' + value);
        });

        Object.keys(seen).forEach(function (label) {
          if (seen[label]) lines.splice(1, 0, label + ': ' + seen[label]);
        });

        if (missing.length) {
          if (error) {
            error.hidden = false;
            error.textContent = (form.getAttribute('data-pr-missing') || 'Please fill in:') + ' ' + missing.join(', ');
          }
          var first = form.querySelector('[aria-invalid="true"]');
          if (first) first.focus();
          return;
        }
        if (error) error.hidden = true;

        var number = (form.getAttribute('data-pr-wa-number') || '').replace(/[^0-9]/g, '');
        var url = 'https://wa.me/' + number + '?text=' + encodeURIComponent(lines.filter(Boolean).join('\n'));
        track('pr_whatsapp_form', { form: form.getAttribute('data-pr-compose') });
        window.open(url, '_blank', 'noopener');
      });
    });
  }

  /* ---------- Weekly nights: highlight tonight (Japan time, nights run past midnight) ---------- */
  function initWeekly(root) {
    $all('[data-pr-weekly]', root).forEach(function (list) {
      try {
        var shifted = new Date(Date.now() - 5 * 3600 * 1000); // 1AM Tuesday is still Monday night
        var day = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Tokyo', weekday: 'short' }).format(shifted).toLowerCase();
        $all('[data-day]', list).forEach(function (row) {
          row.classList.toggle('is-today', row.getAttribute('data-day') === day.slice(0, 3));
        });
      } catch (e) {}
    });
  }

  /* ---------- Map facade (loads Google Maps only when asked) ---------- */
  function initMaps(root) {
    $all('[data-pr-map]', root).forEach(function (wrap) {
      var button = wrap.querySelector('[data-pr-map-load]');
      if (!button || button.__prInit) return;
      button.__prInit = true;
      button.addEventListener('click', function () {
        var iframe = document.createElement('iframe');
        iframe.src = wrap.getAttribute('data-pr-map');
        iframe.title = wrap.getAttribute('data-title') || 'Map';
        iframe.loading = 'lazy';
        iframe.referrerPolicy = 'no-referrer-when-downgrade';
        iframe.allowFullscreen = true;
        wrap.appendChild(iframe);
        button.remove();
      });
    });
  }

  /* ---------- Sticky "Book now" ---------- */
  function initSticky(root) {
    var sticky = document.querySelector('[data-pr-sticky]');
    if (!sticky) return;
    document.body.classList.add('pr-has-sticky');
    if (!('IntersectionObserver' in window)) return;
    if (sticky.__prObserver) sticky.__prObserver.disconnect();
    var visible = new Set();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      });
      sticky.classList.toggle('is-hidden', visible.size > 0);
    }, { threshold: 0.2 });
    $all('[data-pr-sticky-hide]', document).forEach(function (el) { observer.observe(el); });
    sticky.__prObserver = observer;
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var items = $all('.pr-reveal:not(.is-in)', root);
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { observer.observe(el); });
  }

  function init(root) {
    initHero(root);
    initScrollers(root);
    initLightbox(root);
    initComposer(root);
    initWeekly(root);
    initMaps(root);
    initReveal(root);
  }

  function boot() {
    setHeaderHeight();
    init(document);
    initSticky(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.addEventListener('resize', setHeaderHeight);

  // Theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    initSticky(document);
    setHeaderHeight();
  });
})();
